module.exports = __webpack_public_path__ + "img/0Q3A6947_8_P_L_Black.fdf3b902.jpg";